import(/* webpackMode: "eager" */ "/vercel/path0/app/fund/grants/page.tsx");
